import React, { useEffect } from 'react'
import { PopoverText } from 'shared'
import { useCheckGoogleWebfontsPresence } from '../googleWebfontHelper/use_google_webfonts_list'

export const GoogleWebfontCheck = ({ font, selectFont }: { font: string; selectFont: (font: string) => void }) => {
  const googleFontNameOrNull = useCheckGoogleWebfontsPresence(font)

  useEffect(() => {
    if (googleFontNameOrNull) {
      selectFont(googleFontNameOrNull)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleFontNameOrNull])

  return (
    <>
      <div className="absolute right-2 top-105">
        <div className="relative">
          {googleFontNameOrNull ? (
            <PopoverText
              trigger={<button type="button" className="cursor-help fa fa-check text-green-500 text-sm" />}
              placement="left"
              popoverId="tooltip-for-google_webfont_check_all_good"
            >
              {i18n.t(
                'fundraising_events.manage.live_widgets.configurator.font_family.google_webfont_check.all_good_notice'
              )}
            </PopoverText>
          ) : (
            <PopoverText
              trigger={
                <button type="button" className="cursor-help fa fa-exclamation-triangle text-yellow-400 text-sm" />
              }
              placement="left"
              popoverId="tooltip-for-google_webfont_check_warning"
            >
              {i18n.t(
                'fundraising_events.manage.live_widgets.configurator.font_family.google_webfont_check.warning_notice'
              )}
            </PopoverText>
          )}
        </div>
      </div>
    </>
  )
}
